import { IMask } from '../models/i-mask';

export const FORM_MASK: IMask = {
  CONFIRMATION_CODE_SIZE: 5,
  RESCORING_CODE_SIZE: 4,
  RECOVERY_CODE_SIZE: 6,
  CONFIRMATION_LOAN_CODE_SIZE: 4,
  CONFIRMATION_PROLONGATION_CODE_SIZE: 3,

  PHONE_MASK: '(000) 000-00-00',
  SERIES_PASSPORT_MASK: '0000',
  RUBLE_MASK: '9||99||999||9999||99999||999999||9999999',
  AMOUNT_MASK: '1||19||199||1999||19999||199999',
  // PASSPORT_MASK: [ /\d/,  /\d/, /\d/,  /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/ ],
  // SNILS_MASK: [ /\d/,  /\d/, /\d/,  '-', /\d/, /\d/, /\d/,  '-', /\d/, /\d/, /\d/,  ' ', /\d/, /\d/ ],
  DATE_MASK: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
  CODE_MASK: '000-000',
  NUMBER_PASSPORT_MASK: '000000',
  NUM_MASK: '9999999',
  BIC: '000000000',
  INN: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  // CORRESPONDENT_ACCOUNT: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  SETTLEMENT_ACCOUNT: '000-00-000-0-0000-0000000',
  // MAX_LENGTH_MASK: generatingMask(255),
  YANDEX_MASK: '9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?9?',
};
